import React from 'react';
import Login from '../components/login';  

const LoginPage: React.FC = () => {
  console.log('LoginPage');
  return <Login />;
};

export default LoginPage;
